import React, {useState} from 'react';

import { config } from '../../Config/Config';
import {IconButton, InputAdornment, TextField} from "@mui/material";
import {VisibilityOffOutlined, VisibilityOutlined} from '@mui/icons-material';
function PasswordInput(props) {

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = (e) => {setShowPassword(!showPassword)};
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

  return (
    <TextField
      onBlur={props.onBlur}
      onFocus={props.onFocus}
      onChange={(e) => props.onChange(e, e.target.value)}
      value={props.value}
      error={!!props.errorText}
      label={props.floatingLabelText}
      helperText={props.errorText}
      sx={{"& .MuiInputBase-formControl":{
              borderRadius: '12px',
              border: '1px solid',
              borderColor: '#F8F8F8',
              backgroundColor: '#F8F8F8',
          },
          "& .MuiFormLabel-root.Mui-focused": {
              color: `${config.theme.inputFloutingLabelFocus?.color || config.theme.inputFloatingLabel.color} !important`,
              fontWeight:300,
              textColor: 'blue',
          },
          "& .MuiInputBase-root": {
              height: 56, // Set your desired height
              maxWidth: 360
          },

          }}
      variant={'filled'}
      InputLabelProps={{style: config.theme.inputFloatingLabel }}
      type={showPassword ? "text" : "password"}
      InputProps={{
        disableUnderline: true,
        style: {...config.theme.inputStyle},
        endAdornment: (
            <InputAdornment position="end">
                <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                    size="small">
                    {showPassword ? (
                        <VisibilityOutlined style={{fontSize: '18px'}}/>
                    ) : (
                        <VisibilityOffOutlined style={{fontSize: '18px'}}/>
                    )}
                </IconButton>
            </InputAdornment>
            )}}
    />
  );
}

export default PasswordInput;
